import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { useSiteContent } from "@/lib/hooks";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About & Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { data: content } = useSiteContent();
  const navigate = useNavigate();
  const phone = content?.contact_phone || "";

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 md:h-24 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <img src="/logo.png" alt="Speedex International" className="h-14 md:h-20 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-link-${l.label.toLowerCase().split(" ")[0]}`}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors ${
                  isActive ? "text-green-700" : "text-slate-600 hover:text-slate-900"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {phone && (
            <a href={`tel:${phone}`} className="flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-green-700" data-testid="nav-phone">
              <Phone className="h-4 w-4" /> {phone}
            </a>
          )}
          <button
            onClick={() => navigate("/quote")}
            data-testid="nav-quote-btn"
            className="rounded-full bg-green-600 px-5 py-2.5 text-sm font-bold text-white hover:bg-green-700 transition-colors shadow-sm"
          >
            Get a Free Quote
          </button>
        </div>

        <button className="md:hidden p-2 text-slate-700" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-5 py-4 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block px-3 py-3 rounded-lg text-base font-semibold ${
                  isActive ? "bg-green-50 text-green-700" : "text-slate-700"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <button
            onClick={() => { setOpen(false); navigate("/quote"); }}
            className="w-full mt-2 rounded-full bg-green-600 px-5 py-3 text-base font-bold text-white"
            data-testid="nav-mobile-quote-btn"
          >
            Get a Free Quote
          </button>
        </div>
      )}
    </header>
  );
}
